import RankOneBadge from "public/svgs/rank-one-badge.svg?url";
import RankTwoBadge from "public/svgs/rank-two-badge.svg?url";
import RankThreeBadge from "public/svgs/rank-three-badge.svg?url";
import Image from "next/image";

const RankBadge = ({ rank }) => {
  switch (rank) {
    case 1:
      return (
        <Image src={RankOneBadge} alt="rank-1-badge" height={28} width={28} />
      );
    case 2:
      return (
        <Image src={RankTwoBadge} alt="rank-2-badge" height={28} width={28} />
      );
    case 3:
      return (
        <Image src={RankThreeBadge} alt="rank-3-badge" height={28} width={28} />
      );
    default:
      return `#${rank}`;
  }
};
export default RankBadge;
